import React from 'react';
import StyleBuilder from './StyleBuilder';

function TemplateControls({
  templateName, setTemplateName,
  description, setDescription,
  setThumbnail,
  layout, setLayout,
  btnLoading, handleSubmit,
  availableComponents,
  styleConfig, setStyleConfig,
  templateType, setTemplateType,
  selectedModules, setSelectedModules
}) {

  const handleDropdownChange = (part, value) => {
    setLayout(prev => ({ ...prev,[part]: value }));
  };

  const handleModuleToggle = (moduleName) => {
    setSelectedModules(prev => ({
      ...prev,[moduleName]: !prev[moduleName]
    }));
  };

  return (
    <div>
      {/* MAIN PARENT ACCORDION */}
      <div className="accordion shadow-sm" id="templateControlsAccordion">
        
        {/* ==========================================
            SECTION 1: TEMPLATE SETUP & TYPE
        ========================================== */}
        <div className="accordion-item border-0 border-bottom">
          <h2 className="accordion-header" id="headingOne">
            <button className="accordion-button fw-bold text-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
              1. Template Details & Setup
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#templateControlsAccordion">
            <div className="accordion-body bg-white">
              
              <div className="mb-3">
                <label className="form-label text-muted small fw-bold">Template Name</label>
                <input type="text" className="form-control form-control-sm" value={templateName} onChange={e => setTemplateName(e.target.value)} required />
              </div>
              <div className="mb-3">
                <label className="form-label text-muted small fw-bold">Description</label>
                <textarea className="form-control form-control-sm" rows="2" value={description} onChange={e => setDescription(e.target.value)} />
              </div>
              <div className="mb-3">
                <label className="form-label text-muted small fw-bold">Thumbnail Image</label>
                <input type="file" className="form-control form-control-sm" onChange={e => setThumbnail(e.target.files[0])} accept="image/*" required />
              </div>

              <hr className="my-3" />

              <div className="mb-3">
                <label className="form-label text-primary fw-bold">Template Type</label>
                <select className="form-select border-primary bg-light" value={templateType} onChange={e => setTemplateType(e.target.value)}>
                  <option value="Travel Website">Travel Website</option>
                  <option value="B2C Website">B2C Website</option>
                </select>
              </div>

              {templateType === 'B2C Website' && (
                <div className="p-3 bg-light rounded border border-info">
                  <label className="form-label fw-bold text-dark mb-3 border-bottom pb-2 d-block">Enable B2C Modules</label>
                  <div className="row g-2">
                    {Object.keys(selectedModules).map(mod => (
                      <div className="col-6" key={mod}>
                        <div className="form-check form-switch">
                          <input 
                            className="form-check-input" 
                            type="checkbox" 
                            id={`mod-${mod}`} 
                            checked={selectedModules[mod]} 
                            onChange={() => handleModuleToggle(mod)} 
                          />
                          <label className="form-check-label small" htmlFor={`mod-${mod}`}>{mod}</label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            </div>
          </div>
        </div>

        {/* ==========================================
            SECTION 2: LAYOUT BUILDER (DYNAMIC)
        ========================================== */}
        <div className="accordion-item border-0 border-bottom">
          <h2 className="accordion-header" id="headingTwo">
            <button className="accordion-button collapsed fw-bold text-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
              2. Layout Builder
            </button>
          </h2>
          <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#templateControlsAccordion">
            <div className="accordion-body bg-light">
              
              {/* --- Core Elements --- */}
              <h6 className="mb-3 text-secondary text-uppercase" style={{fontSize: '0.8rem', letterSpacing: '1px'}}>Core Layout</h6>
              
              <div className="mb-3 bg-white p-2 rounded border">
                <label className="form-label small fw-bold">Top Bar Style</label>
                <select className="form-select form-select-sm" value={layout.topBar} onChange={e => handleDropdownChange('topBar', e.target.value)}>
                  {availableComponents.topBars.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3 bg-white p-2 rounded border">
                <label className="form-label small fw-bold">Header Style</label>
                <select className="form-select form-select-sm" value={layout.header} onChange={e => handleDropdownChange('header', e.target.value)}>
                  {availableComponents.headers.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3 bg-white p-2 rounded border">
                <label className="form-label small fw-bold">Hero Banner Style</label>
                <select className="form-select form-select-sm" value={layout.hero} onChange={e => handleDropdownChange('hero', e.target.value)}>
                  {availableComponents.heroes.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3 bg-white p-2 rounded border">
                <label className="form-label small fw-bold">Footer Style</label>
                <select className="form-select form-select-sm" value={layout.footer} onChange={e => handleDropdownChange('footer', e.target.value)}>
                  {availableComponents.footers.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>

              <hr className="my-4" />
              <h6 className="mb-3 text-secondary text-uppercase" style={{fontSize: '0.8rem', letterSpacing: '1px'}}>Page Modules</h6>

              {/* --- NESTED COLLAPSIBLE MODULES --- */}
              <div className="module-collapses">
                
                {/* 1. Packages Section */}
                {(templateType === 'Travel Website' || (templateType === 'B2C Website' && selectedModules.Packages)) && (
                  <div className="accordion-item mb-3 border-0 border-start border-primary border-4 rounded bg-white shadow-sm overflow-hidden">
                    <h2 className="accordion-header" id="headingPkg">
                      {/* Notice "collapsed" is removed and "show" is on the div below so Packages stays open by default */}
                      <button className="accordion-button py-2 fw-bold text-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapsePkg" style={{backgroundColor: 'transparent', boxShadow: 'none'}}>
                        🎒 Packages Module
                      </button>
                    </h2>
                    <div id="collapsePkg" className="accordion-collapse collapse show">
                      <div className="accordion-body p-3 pt-0 border-top mt-2">
                        <div className="mb-2">
                          <label className="form-label small text-muted">Destinations Block</label>
                          <select className="form-select form-select-sm" value={layout.destinations} onChange={e => handleDropdownChange('destinations', e.target.value)}>
                            {availableComponents.destinations.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                        <div className="mb-2">
                          <label className="form-label small text-muted">Featured Packages (Home)</label>
                          <select className="form-select form-select-sm" value={layout.packages} onChange={e => handleDropdownChange('packages', e.target.value)}>
                            {availableComponents.packages.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                        <div className="mb-2">
                          <label className="form-label small text-muted">Full Packages List Page</label>
                          <select className="form-select form-select-sm" value={layout.packagesPage} onChange={e => handleDropdownChange('packagesPage', e.target.value)}>
                            {availableComponents.packagesPage.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                        <div className="mb-0">
                          <label className="form-label small text-muted">Package Details Page</label>
                          <select className="form-select form-select-sm" value={layout.detailsPage} onChange={e => handleDropdownChange('detailsPage', e.target.value)}>
                            {availableComponents.detailsPage.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 2. Flights Section */}
                {templateType === 'B2C Website' && selectedModules.Flights && (
                <div className="p-3 mb-3 border-start border-info border-4 rounded bg-white shadow-sm overflow-hidden">
                    <h2 className="accordion-header" id="headingFlights">
                      <button className="accordion-button collapsed py-2 fw-bold text-info" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFlights" style={{backgroundColor: 'transparent', boxShadow: 'none'}}>
                        ✈️ Flights Module
                      </button>
                    </h2>
                    <div id="collapseFlights" className="accordion-collapse collapse">
                      <div className="accordion-body p-3 pt-0 border-top mt-2">
                        <div className="mb-0">
                          {/* 👇 CHANGED THIS TO THEME SELECTION */}
                          <label className="form-label small text-muted">Select Flight Theme (Applies to all flight pages)</label>
                          <select className="form-select form-select-sm" value={layout.flightTheme} onChange={e => handleDropdownChange('flightTheme', e.target.value)}>
                            {availableComponents.flightThemes.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                      </div>
                    </div>
                </div>
              )}

                {/* 3. Hotels Section */}
                {templateType === 'B2C Website' && selectedModules.Hotels && (
                  <div className="accordion-item mb-3 border-0 border-start border-warning border-4 rounded bg-white shadow-sm overflow-hidden">
                    <h2 className="accordion-header" id="headingHotels">
                      <button className="accordion-button collapsed py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseHotels" style={{color: '#d39e00', backgroundColor: 'transparent', boxShadow: 'none'}}>
                        🏨 Hotels Module
                      </button>
                    </h2>
                    <div id="collapseHotels" className="accordion-collapse collapse">
                      <div className="accordion-body p-3 pt-0 border-top mt-2">
                        <div className="mb-0">
                          <label className="form-label small text-muted">Hotel Search UI</label>
                          <select className="form-select form-select-sm" value={layout.hotelsPage} onChange={e => handleDropdownChange('hotelsPage', e.target.value)}>
                            {availableComponents.hotelsPage.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 4. Visas Section */}
                {templateType === 'B2C Website' && selectedModules.Visas && (
                  <div className="accordion-item mb-3 border-0 border-start border-success border-4 rounded bg-white shadow-sm overflow-hidden">
                    <h2 className="accordion-header" id="headingVisas">
                      <button className="accordion-button collapsed py-2 fw-bold text-success" type="button" data-bs-toggle="collapse" data-bs-target="#collapseVisas" style={{backgroundColor: 'transparent', boxShadow: 'none'}}>
                        🛂 Visas Module
                      </button>
                    </h2>
                    <div id="collapseVisas" className="accordion-collapse collapse">
                      <div className="accordion-body p-3 pt-0 border-top mt-2">
                        <div className="mb-0">
                          <label className="form-label small text-muted">Visa Request UI</label>
                          <select className="form-select form-select-sm" value={layout.visasPage} onChange={e => handleDropdownChange('visasPage', e.target.value)}>
                            {availableComponents.visasPage.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 5. Sightseeing Section */}
                {templateType === 'B2C Website' && selectedModules.Sightseeing && (
                  <div className="accordion-item mb-3 border-0 border-start border-danger border-4 rounded bg-white shadow-sm overflow-hidden">
                    <h2 className="accordion-header" id="headingSightseeing">
                      <button className="accordion-button collapsed py-2 fw-bold text-danger" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSightseeing" style={{backgroundColor: 'transparent', boxShadow: 'none'}}>
                        🗺️ Sightseeing Module
                      </button>
                    </h2>
                    <div id="collapseSightseeing" className="accordion-collapse collapse">
                      <div className="accordion-body p-3 pt-0 border-top mt-2">
                        <div className="mb-0">
                          <label className="form-label small text-muted">Sightseeing UI</label>
                          <select className="form-select form-select-sm" value={layout.sightseeingPage} onChange={e => handleDropdownChange('sightseeingPage', e.target.value)}>
                            {availableComponents.sightseeingPage.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 6. Buses Section */}
                {/* 6. Buses Section */}
                {templateType === 'B2C Website' && selectedModules.Buses && (
                  <div className="accordion-item mb-3 border-0 border-start border-secondary border-4 rounded bg-white shadow-sm overflow-hidden">
                    <h2 className="accordion-header" id="headingBuses">
                      <button className="accordion-button collapsed py-2 fw-bold text-secondary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBuses" style={{backgroundColor: 'transparent', boxShadow: 'none'}}>
                        🚌 Buses Module
                      </button>
                    </h2>
                    <div id="collapseBuses" className="accordion-collapse collapse">
                      <div className="accordion-body p-3 pt-0 border-top mt-2">
                        <div className="mb-0">
                          <label className="form-label small text-muted">Select Bus Theme</label>
                          {/* 👇 FIX THIS LINE: map over busThemes, and update 'busTheme' */}
                          <select className="form-select form-select-sm" value={layout.busTheme} onChange={e => handleDropdownChange('busTheme', e.target.value)}>
                            {availableComponents.busThemes.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* 7. Cars Section */}
                {templateType === 'B2C Website' && selectedModules.Cars && (
                  <div className="accordion-item mb-3 border-0 border-start border-dark border-4 rounded bg-white shadow-sm overflow-hidden">
                    <h2 className="accordion-header" id="headingCars">
                      <button className="accordion-button collapsed py-2 fw-bold text-dark" type="button" data-bs-toggle="collapse" data-bs-target="#collapseCars" style={{backgroundColor: 'transparent', boxShadow: 'none'}}>
                        🚗 Cars Module
                      </button>
                    </h2>
                    <div id="collapseCars" className="accordion-collapse collapse">
                      <div className="accordion-body p-3 pt-0 border-top mt-2">
                        <div className="mb-0">
                          <label className="form-label small text-muted">Car Rental UI</label>
                          <select className="form-select form-select-sm" value={layout.carsPage} onChange={e => handleDropdownChange('carsPage', e.target.value)}>
                            {availableComponents.carsPage.map(name => <option key={name} value={name}>{name}</option>)}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                
              </div>
              {/* --- END NESTED COLLAPSIBLE MODULES --- */}

              <hr className="my-4" />
              <h6 className="mb-3 text-secondary text-uppercase" style={{fontSize: '0.8rem', letterSpacing: '1px'}}>Extra Sections</h6>

              <div className="mb-3 bg-white p-2 rounded border">
                <label className="form-label small fw-bold">Testimonials Style</label>
                <select className="form-select form-select-sm" value={layout.testimonials} onChange={e => handleDropdownChange('testimonials', e.target.value)}>
                  {availableComponents.testimonials.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3 bg-white p-2 rounded border">
                <label className="form-label small fw-bold">About Us Style</label>
                <select className="form-select form-select-sm" value={layout.aboutUs} onChange={e => handleDropdownChange('aboutUs', e.target.value)}>
                  {availableComponents.aboutUs.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>

            </div>
          </div>
        </div>

        {/* ==========================================
            SECTION 3: STYLE BUILDER
        ========================================== */}
        <div className="accordion-item border-0">
          <h2 className="accordion-header" id="headingThree">
            <button className="accordion-button collapsed fw-bold text-primary" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree">
              3. Style Builder
            </button>
          </h2>
          <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#templateControlsAccordion">
            <div className="accordion-body bg-white">
              <StyleBuilder styleConfig={styleConfig} setStyleConfig={setStyleConfig} />
            </div>
          </div>
        </div>

      </div>

      <div className="d-grid mt-4">
        <button type="button" className="btn btn-primary btn-lg w-100 shadow" disabled={btnLoading} onClick={handleSubmit}>
          {btnLoading ? 'Saving Blueprint...' : 'Save Template'}
        </button>
      </div>
    </div>
  );
}

export default TemplateControls;